module.exports = __webpack_public_path__ + "static/preview-bslgov-69f02705381497fe6ebb8cd90723fe8f.png";